// parent class for Plan Comparison
// implements by child class
export class PlanComparison {
  // props from component
  props;
  // result for dom
  treeData;
  // template data for building result
  tableData = {};

  constructor(props = {}) {
    this.props = props;
  }

  initTable() {
    this.tableData = [];
    return this;
  }

  filterBy() {
    return this;
  }

  buildTree() {
    return this;
  }

  build() {
    this.initTable().filterBy().buildTree()
    return this;
  }

  get resultGetter() {
    return this.treeData;
  }

}









